// extracted by mini-css-extract-plugin
export default {"top":"Top_top__+dHDJ","backgroundAnimation":"Top_backgroundAnimation__3DZCe"};